// extracted by mini-css-extract-plugin
module.exports = {"card":"n_c"};